export const API_URL = import.meta.env.VITE_API_URI;

export const COGNITO_AUTHORITY = import.meta.env.VITE_COGNITO_AUTHORITY;

export const COGNITO_CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID;
